import React from "react";
import "./Hero.css";

export const Hero = () => {
  return (
    <div className="hero">
      <div className="hero__content">
        <h3 className="hero__date">
          Puerto Escondido, Oxaca
          {/* <span className="hero__highlight">Something</span> */}
        </h3>
        <h1 className="hero__title">
          Atrapa la Ola,
          <br /> Vive el Momento
        </h1>
      </div>
    </div>
  );
};
